import React from 'react';
import './Tag.less';
import { TagTypes } from '../../types';

export type TagProps = {
  type?: TagTypes;
  style?: React.CSSProperties;
};

const TTag: React.FC<TagProps> = ({
  children,
  style,
  type = 'positive',
  ...props
}) => {
  const classNames = ['t-tag', `t-tag-${type}`];

  return (
    <span style={style} className={classNames.join(' ')} {...props}>
      {children}
    </span>
  );
};

export default TTag;
